<template>
  <v-tabs class="mt-0" v-model="currentAttributeTab">
    <v-tab> ATTRIBUTES</v-tab>
    <v-tab v-show="admin.selectedAttribute != null">{{
      attributeTabName
    }}</v-tab>
    <v-tab-item class="pa-2">
      <attribute-list></attribute-list>
    </v-tab-item>
    <v-tab-item class="pa-2">
      <v-row>
        <v-col>
          <attribute-edit></attribute-edit>
        </v-col>
        <v-col>
          <attribute-details
            v-show="
              admin.selectedAttribute != null &&
              admin.selectedAttribute.id != 'new' &&
              selectedAttributeHasValues
            "
          ></attribute-details>
        </v-col>
      </v-row>
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import { mapState } from 'vuex';
  import AttributeEdit from '../components/attribute/AttributeEdit.vue';
  import AttributeList from '../components/attribute/AttributeList.vue';
  import AttributeDetails from '../components/attribute/AttributeDetails.vue';

  export default {
    components: { AttributeList, AttributeEdit, AttributeDetails },
    data() {
      return {};
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectedAttributeHasValues: {
        get() {
          var controlTypesWithValues = [
            'DropDownList',
            'MultiSelect',
            'MultiInt',
            'MultiDecimal',
            'MultiCheckBox',
            'MultiSelect'
          ];
          return controlTypesWithValues.includes(
            this.admin.selectedAttribute?.controlType
          );
        }
      },
      currentAttributeTab: {
        get() {
          return this.admin.currentAttributeTab;
        },
        set(value) {
          this.$store.commit('admin/setCurrentAttributeTab', value);
        }
      },
      attributeTabName: {
        get() {
          let tabName = 'Edit Attribute';
          if (
            this.admin.selectedAttribute &&
            this.admin.selectedAttribute.id != 'new'
          ) {
            tabName = `Attribute [${this.admin.selectedAttribute.name?.substring(
              0,
              20
            )}${this.admin.selectedAttribute.name?.length > 20 ? '...' : ''}]`;
          } else if (
            this.admin.selectedAttribute &&
            this.admin.selectedAttribute.id == 'new'
          ) {
            tabName = 'Add New Attribute';
          }
          return tabName;
        }
      }
    }
  };
</script>
